var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSportbetExternalLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#EFBF13"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#EFBF13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5H5C4.725 11.5 4.5 11.275 4.5 11V5C4.5 4.725 4.725 4.5 5 4.5H7.5C7.775 4.5 8 4.275 8 4C8 3.725 7.775 3.5 7.5 3.5H4.5C3.945 3.5 3.5 3.95 3.5 4.5V11.5C3.5 12.05 3.95 12.5 4.5 12.5H11.5C12.05 12.5 12.5 12.05 12.5 11.5V8.5C12.5 8.225 12.275 8 12 8C11.725 8 11.5 8.225 11.5 8.5V11C11.5 11.275 11.275 11.5 11 11.5ZM9 4C9 4.275 9.225 4.5 9.5 4.5H10.795L6.23 9.065C6.035 9.26 6.035 9.575 6.23 9.77C6.425 9.965 6.74 9.965 6.935 9.77L11.5 5.205V6.5C11.5 6.775 11.725 7 12 7C12.275 7 12.5 6.775 12.5 6.5V4C12.5 3.725 12.275 3.5 12 3.5H9.5C9.225 3.5 9 3.725 9 4Z",
    fill: "#0064A6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportbetExternalLink);
export default __webpack_public_path__ + "static/media/sportbetExternalLink.94e863c455edfeb4c95e08e41e95bc3a.svg";
export { ForwardRef as ReactComponent };